import {
  ACCOUNTANT_DASHBOARD_PAGE_URL,
  DASHBOARD_PAGE_URL,
  MANAGER_DASHBOARD_PAGE_URL,
  SYSTEM_USER_DASHBOARD_PAGE_URL,
} from '@/api/core/links';
import { SOCIAL_NETWORK_MOCK_ENABLED } from '@/app/consts/featureFlags';
import { SYSTEM_HOME_PAGE_URL } from '@/app/consts/systemHomePage';
import { ContactType } from '@/app/models/Contact';

const USER_TYPE_DEFAULT_ROUTE: Partial<Record<ContactType, string>> = {
  [ContactType.COMMUNITY]: MANAGER_DASHBOARD_PAGE_URL,
  [ContactType.ACCOUNTANT]: ACCOUNTANT_DASHBOARD_PAGE_URL,
  [ContactType.ADMIN]: DASHBOARD_PAGE_URL,
  [ContactType.SYSTEM_USER]: SYSTEM_USER_DASHBOARD_PAGE_URL,
};

export function getAuthenticatedLandingRoute(userType: ContactType): string {
  const usesSystemUserRoutes = userType === ContactType.ADMIN || userType === ContactType.SYSTEM_USER;
  const usesSocialHome = SOCIAL_NETWORK_MOCK_ENABLED && usesSystemUserRoutes;
  if (usesSocialHome) return SYSTEM_HOME_PAGE_URL;

  const landingRoute = USER_TYPE_DEFAULT_ROUTE[userType] ?? SYSTEM_HOME_PAGE_URL;
  return landingRoute;
}
